module.exports = __webpack_public_path__ + "static/img/menage3.5902ca09.jpg";